import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';

import './styles.css';

const Hero = ({
    buttonsList,
    className,
    copy,
    children,
    header,
    image,
    youtubeId,
    vimeoId,
}) => (
    <div
        className={`${
            className ? `${className} ` : ''
        }hero parallax-section text-light`}
    >
        {header && <h1 style={{ textTransform: 'uppercase' }}>{header}</h1>}
        {copy && <p>{copy}</p>}
        {buttonsList?.length && <div className="btns">{buttonsList}</div>}
        {youtubeId && (
            <iframe
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                frameborder="0"
                height="315"
                id="video-embed"
                src={`https://www.youtube.com/embed/${youtubeId}`}
                title="YouTube video player"
                width="560"
            ></iframe>
        )}
        {vimeoId && (
            <iframe
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                frameborder="0"
                height="361"
                id="video-embed"
                src={`https://player.vimeo.com/video/${vimeoId}`}
                title="Vimeo video player"
                width="640"
            ></iframe>
        )}

        {children}
        <Img
            className="parallax-layer parallax-back"
            fluid={image}
            imgStyle={{ objectPosition: '30% center' }}
            // because of how Gatsby Img works, need to use `style` here and cannot style via css
            style={{
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                zIndex: '-1',
            }}
        />
    </div>
);

Hero.propTypes = {
    buttonsList: PropTypes.arrayOf(PropTypes.element),
    copy: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    header: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    image: PropTypes.object.isRequired,
};

export default Hero;
